import React, { Component } from "react";
// import Loader from "./loader";

class TeamOverview extends Component {
  state = {
    teamData: null,
    loading: true,
    error: null,
    title: "",
    section_title: "",
    teacher_section: [],
    siteLanguage: "",
  };

  componentDidMount() {
    const siteLanguage = localStorage.getItem("siteLanguage") || "en";
    this.setState.siteLanguage = siteLanguage;
  }

  render() {
    return (
      <div
        className={`container-fluid team py-3 mt-3 ${
          this.setState.siteLanguage === "ur" ? " direction-rtl" : ""
        }`}
      >
        <div className="container">
          {/* Heading */}
          <div
            className="text-center mx-auto mb-3 wow fadeIn"
            data-wow-delay="0.1s"
            style={{ maxWidth: "700px" }}
          >
            {this.setState.siteLanguage === "ur" ? (
              <p className="fs-5 text-uppercase text-primary">
                علمِ دین کی روشنی: ایک درخشاں میراث، ایک بابرکت مشن
              </p>
            ) : this.setState.siteLanguage === "ro" ? (
              <p className="fs-5 text-uppercase text-primary">
                Ilm-e-Deen Ki Roshni: Ek Darakhshaan Meeraas, Ek Babarkat
                Mission
              </p>
            ) : (
              <p className="fs-5 text-uppercase text-primary">
                The Light of Religious Knowledge: A Glorious Legacy, A Blessed
                Mission
              </p>
            )}
          </div>

          {/* Introduction */}
          <div className="mb-4">
            {this.setState.siteLanguage === "ur" ? (
              <>
                {/* Urdu translation here */}
                <p>
                  <strong>
                    بسم اللہ الرحمٰن الرحیم
                  </strong>
                </p>
                <p>
                  اور اس سے زیادہ کس کی بات اچھی جو اللہ کی طرف بلائے، نیکی کرے اور کہے میں مسلمان ہوں۔
                  <br />
                  <em>(سورہ فصلت: آیت 33)</em>
                </p>
                <p>
                  اللہ تعالیٰ نے انسان کو محض تفریح کے لیے پیدا نہیں کیا، بلکہ اسے ایک مقصد، ایک ہدایت اور ایک عظیم فریضے کے ساتھ دنیا میں بھیجا۔ اس ہدایت کا سرچشمہ قرآنِ مجید اور سنتِ مصطفیٰ صلی اللہ علیہ وسلم ہے۔ انہی دونوں ماخذوں کے فہم اور عمل کا ذریعہ علمِ دین ہے، جو انسان کو اُس کے خالق سے جوڑتا ہے، بندگی کی راہ دکھاتا ہے، اور اُسے دنیا و آخرت کی کامیابی عطا کرتا ہے۔
                </p>
              </>
            ) : this.setState.siteLanguage === "ro" ? (
              <>
                {/* Roman Urdu translation here */}
                <p>
                  <strong>
                    Bismillah Hir Rahman Nir Raheem
                  </strong>
                </p>
                <p>
                 Aur Us Se Zyada Kis Ki Baat Achi Jo Allah Ki Taraf Bulaye, Neki Kare Aur Kahe Main Musalman Hoon.
                  <br />
                  <em>(Surah Fussilat: Aayat 33)</em>
                </p>
                <p>
                 Allah Ta’ala Ne Insaan Ko Mehz Tafreeh Ke Liye Paida Nahin Kiya, Balki Use Ek Maqsad, Ek Hidaayat Aur Ek Azeem Fareez e Ke Saath Duniya Mein Bheja. Is Hidaayat Ka Sarchashma Qur’an Majeed Aur Sunnat-e-Mustafa Sallallahu Alaihi Wasallam Hai. Inhi Dono Maakhzon Ke Fahm Aur Amal Ka Zariya Ilm-e-Deen Hai, Jo Insaan Ko Us Ke Khaaliq Se Jodta Hai, Bandagi Ki Raah Dikhata Hai, Aur Use Duniya O Aakhirat Ki Kamiyabi Ata Karta Hai.
                </p>
              </>
            ) : (
              <>
                <p>
                  <strong>
                    In the name of Allah, the Most Gracious, the Most Merciful
                  </strong>
                </p>
                <p>
                  And who is better in speech than one who invites to Allah,
                  does righteousness, and says, “Indeed, I am of the Muslims.”
                  <br />
                  <em>(Surah Fussilat: Verse 33)</em>
                </p>
                <p>
                  Allah Almighty did not create man merely for amusement, but
                  with a purpose, a divine guidance, and a noble mission. The
                  source of this guidance is the Holy Qur'an and the Sunnah of
                  the Prophet Muhammad (peace be upon him). The understanding
                  and practice of these two sources come through religious
                  knowledge (Ilm-e-Deen), which connects a person with their
                  Creator, shows the path of servitude, and grants success in
                  both this world and the Hereafter.
                </p>
              </>
            )}
          </div>

          {/* Ilm-e-Deen: A Divine Blessing */}
          <div className="mb-4">
            {this.setState.siteLanguage === "ur" ? (
              <>
                <h4>علمِ دین: ایک ربانی نعمت</h4>
                <p>علمِ دین صرف معلومات کا مجموعہ نہیں بلکہ یہ ایک روحانی روشنی ہے، جو دلوں کو زندہ کرتی ہے، کردار کو سنوارتی ہے، اور انسان کو اُس کے مقصدِ تخلیق سے آشنا کرتی ہے۔ ہر دَور میں اللہ تعالیٰ نے ایسے نفوسِ قدسیہ پیدا فرمائے، جنہوں نے علمِ دین کو اپنی زندگیاں بنا لیا، اور اپنی دعوت، تعلیم اور عمل سے معاشروں میں تبدیلی پیدا کی۔</p>
              </>
            ) : this.setState.siteLanguage === "ro" ? (
              <>
                <h4>Ilm-e-Deen: Ek Rabbani Naimat</h4>
                <p>Ilm-e-Deen Sirf Maloomat Ka Majmooa Nahin Balke Ye Ek Roohani Roshni Hai, Jo Dilon Ko Zinda Karti Hai, Kirdaar Ko Sanwaarti Hai, Aur Insaan Ko Apne Maqsad-e-Takhleeq Se Aashna Karti Hai. Har Daur Mein Allah Ta’ala Ne Aise Nufoos-e-Qudsiyyah Paida Farmaaye, Jinhu Ne Ilm-e-Deen Ko Apni Zindagiyan Bana Liya, Aur Apni Da’wat, Taleem Aur Amal Se Muasharon Mein Tabdeeli Paida Ki.</p>
              </>
            ) : (
              <>
                <h4>Ilm-e-Deen: A Divine Blessing</h4>
                <p>
                  Religious knowledge is not just a collection of information—it
                  is a spiritual light that revives hearts, refines character,
                  and introduces a person to the true purpose of creation. In
                  every era, Allah has raised noble souls who dedicated their
                  lives to this sacred knowledge and brought positive change to
                  society through their teachings, actions, and sincere efforts.
                </p>
              </>
            )}
          </div>

          {/* Shining Examples */}
          <div className="mb-4">
            {this.setState.siteLanguage === "ur" ? (
              <>
                <h4>علم و دعوت کی روشن مثالیں</h4>
                <h5>حافظ عامر قادری</h5>
                <p>اس دَور میں، "We Love Islam" جیسے مؤثر پلیٹ فارم کے ذریعے دین کی دعوت کو جدید انداز میں عام کرنے والے حضرت حافظ عامر قادری صاحب کا کردار نمایاں ہے۔ ان کی نعت گوئی، تصوف کی تعلیمات، اور آن لائن دروس لاکھوں لوگوں کے دلوں کو عشقِ رسول صلی اللہ علیہ وسلم سے منور کر چکے ہیں۔ وہ اس بات کی عملی مثال ہیں کہ ایک سچا مسلمان ہر دَور میں دین کی شمع روشن رکھتا ہے۔</p>
                <h5>مفتی ابو سعید مصباحی</h5>
                <p>جامعہ اشرفیہ مبارکپور کے فاضل، فقیہ اور محقق، حضرت مفتی ابو سعید مصباحی صاحب کی علمی، تحقیقی اور دعوتی خدمات بھی قابلِ رشک ہیں۔ ان کا طرزِ بیان سادہ مگر مدلل، اور ان کی شخصیت علم و تقویٰ کا حسین امتزاج ہے۔ انہوں نے دین کو صرف پڑھایا نہیں، بلکہ اس پر عمل کر کے دکھایا کہ حقیقی علم وہی ہے جو تقویٰ، عمل اور اخلاص کو پیدا کرے۔</p>
              </>
            ) : this.setState.siteLanguage === "ro" ? (
              <>
                <h4>Ilm O Da’wat Ki Roshan Misaalen</h4>
                <h5>Hafiz Aamir Qadri</h5>
                <p>Is Daur Mein, “We Love Islam” Jaise Mo’assar Platform Ke Zariye Deen Ki Da’wat Ko Jadeed Andaaz Mein Aam Karne Wale Hazrat Hafiz Aamir Qadri Sahab Ka Kirdaar Numaya Hai. Unki Naat Goi, Tasawwuf Ki Taleemaat, Aur Online Duroos Laakhon Logon Ke Dilon Ko Ishq-e-Rasool Sallallahu Alaihi Wasallam Se Munawwar Kar Chuke Hain. Who Is Baat Ki Amali Misaal Hain Ke Ek Sacha Musalmaan Har Daur Mein Deen Ki Shama Roshan Rakhta Hai.</p>
                <h5>Mufti Abu Saeed Misbahi</h5>
                <p>Jamia Ashrafia Mubarakpur Ke Fadil, Faqeeh Aur Muhaqqiq, Hazrat Mufti Abu Saeed Misbahi Sahab Ki Ilmi, Tehqeeqi Aur Da’wati Khidmaat Bhi Qabil-e-Rashk Hain. Unka Tarz-e-Bayaan Saada Magar Mudallal, Aur Unki Shakhsiyat Ilm O Taqwa Ka Haseen Imtizaaj Hai. Unho Ne Deen Ko Sirf Parhaya Nahin, Balki Is Par Amal Kar Ke Dikhaya Ke Haqeeqi Ilm Wohi Hai Jo Taqwa, Amal Aur Ikhlaas Ko Paida Karen.</p>
              </>
            ) : (
              <>
                <h4>Shining Examples of Knowledge and Preaching</h4>
                <h5>Hafiz Aamir Qadri</h5>
                <p>
                  In this era, Hafiz Aamir Qadri stands out for his efforts in
                  spreading the message of Islam through modern platforms like
                  We Love Islam. His recitations of Naats, teachings on
                  Tasawwuf, and online sermons have ignited love for the Prophet
                  Muhammad (peace be upon him) in the hearts of millions.
                </p>
                <h5>Mufti Abu Saeed Misbahi</h5>
                <p>
                  A graduate of Jamia Ashrafia Mubarakpur, Mufti Abu Saeed
                  Misbahi is a renowned jurist, scholar, and researcher. His
                  speech is simple yet well-reasoned, and his personality is a
                  beautiful blend of knowledge and piety.
                </p>
              </>
            )}
          </div>

          {/* Need for Knowledge */}
          <div className="mb-4">
            {this.setState.siteLanguage === "ur" ? (
              <>
                <h4>موجودہ دَور میں علمِ دین کی ضرورت</h4>
                <p>
                  نبی کریم صلی اللہ علیہ وسلم کا ارشادِ مبارک ہے:
                  <br />
                  <em>"جس کے ساتھ اللہ بھلائی کا ارادہ فرماتا ہے، اُسے دین کی سمجھ عطا فرماتا ہے"</em>
                  <br />
                  <strong>(صحیح بخاری)</strong>
                </p>
                <p>آج کا دَور فکری انتشار، بے راہ روی اور مذہبی بیزاری نے نئی نسل کو گمراہی کے دہانے پر لا کھڑا کیا ہے۔ ایسے ماحول میں صرف علمِ دین ہی وہ نور ہے جو انسان کو خدا کی معرفت، رسولِ پاک صلی اللہ علیہ وسلم کی محبت، اور اخلاق و کردار کی بلندی عطا کر سکتا ہے۔</p>
              </>
            ) : this.setState.siteLanguage === "ro" ? (
              <>
                <h4>Maujooda Daur Mein Ilm-e-Deen Ki Zarurat</h4>
                <p>
                  Nabi Kareem Sallallahu Alaihi Wasallam Ka Irshaad-e-Mubarak Hai.
                  <br />
                  <em>Jis Ke Saath Allah Bhalaai Ka Iraada Farmaata Hai, Usay Deen Ki Samajh Ata Farmaata Hai”</em>
                  <br />
                  <strong>(Saheeh Bukhari)</strong>
                </p>
                <p>Aaj Ka Daur Fikri Inteshaar. Bay Raah Rawi Aur Mazhabi Bezaari Ne Nayi Nasl Ko Gumraahi Ke Dehaane Par La Khada Kiya Hai. Aise Mahaul Mein Sirf Ilm-e-Deen Hi Who Noor Hai Jo Insaan Ko Khuda Ki Ma’rifat, Rasool-e-Paak Sallallahu Alaihi Wasallam Ki Mohabbat, Aur Ikhlaaq O Kirdaar Ki Bulandi Ata Kar Sakta Hai.</p>
              </>
            ) : (
              <>
                <h4>The Need for Religious Knowledge Today</h4>
                <p>
                  The Prophet Muhammad (peace be upon him) said:
                  <br />
                  <em>
                    "If Allah intends good for someone, He gives him
                    understanding of the religion."
                  </em>
                  <br />
                  <strong>(Sahih Bukhari)</strong>
                </p>
                <p>
                  Today, we are living in an era of confusion, misguidance, and
                  growing apathy toward religion. In such times, only religious
                  knowledge can serve as the light that connects people with
                  their Creator.
                </p>
              </>
            )}
          </div>

          {/* About Learn Quran Easily */}
          <div className="mb-4">
            {this.setState.siteLanguage === "ur" ? (
              <>
                <h4>Learn Quran Easily: ایک روشن مشن</h4>
                <p>اسی احساسِ ذمہ داری اور دینی بیداری کے جذبے کے تحت "Learn Quran Easily" کی بنیاد رکھی گئی۔ اس پلیٹ فارم کا مقصد یہ ہے کہ علمِ دین ہر عمر، ہر طبقے، اور ہر ماحول کے فرد کے لیے سہل، جامع اور مقصدی ہو۔</p>
                <ul>
                  <li>یہاں پیش کیے جانے والے اہم کورسز درج ذیل ہیں:</li>
                  <li>قرآنِ کریم: تجوید، قراءت اور حفظ کے ساتھ ساتھ</li>
                  <li>عقائدِ اسلامیہ جیسے کہ نماز، روزہ، زکوٰۃ، حج اور</li>
                  <li>سیرتِ نبوی صلی اللہ علیہ وسلم جیسے کورسز شامل ہیں۔</li>
                  <li>اس کے ساتھ ساتھ فقہ و تفسیر: بہارِ شریعت</li>
                  <li>خواتین، بچوں اور اردو خواں افراد کے لیے الگ نصاب تیار کیا گیا ہے۔</li>
                </ul>
                <p>ان تمام کورسز کی نگرانی ماہر و مخلص اساتذہ کے ذریعے ہو رہی ہے، تاکہ علم کتابوں سے نکل کر دل و عمل کا حصہ بن جائے۔</p>
              </>
            ) : this.setState.siteLanguage === "ro" ? (
              <>
                <h4>Learn Quran Easily: Ek Roshan Mission</h4>
                <p>Isi Ehsas-e-Zimmedari Aur Deeni Bedaari Ke Jazbe Ke Tehat “Learn Quran Easily” Ki Bunyad Rakhi Gayi. Is Platform Ka Maqsad Ye Hai Ke Ilm-e-Deen Har Umar, Har Tabaqay, Aur Har Mahaul Ke Fard Ke Liye Sahal, Jaami’ Aur Maqsadi Ho.</p>
                <ul>
                  <li>Yahan Paish Kiye Jaane Wale Ahem Courses Darj Zail Hain:</li>
                  <li>Qur’an-e-Kareem: Tajweed, Qira’at Aur Hifz Ke Saath Saath</li>
                  <li>Aqaaid-e-Islamiya Jaise Ke Namaz, Roza, Zakaat, Hajj Aur</li>
                  <li>Seerat-e-Nabwi Jaise Courses Shamil Hai.</li>
                  <li>Uske Saath Saath Fiqh O Tafseer: Bahar-e-Shari’at</li>
                  <li>Khawateen, O Bachon Aur Urdu Khwan Afrad Ke Liye Alag Nisaab Tayyar Kiya Gya Hai</li>
                </ul>
                <p>In Tamaam Courses Ki Nigrani Maahir O Mukhlis Ustaazon Ke Zariye Ho Rahi Hai, Taake Ilm Kitaabon Se Nikal Kar Dil O Amal Ka Hissa Ban Jaye.</p>
              </>
            ) : (
              <>
                <h4>Learn Quran Easily: A Radiant Mission</h4>
                <p>
                  With a sense of responsibility and the spirit of Islamic
                  awakening, Learn Quran Easily was founded. This platform is
                  dedicated to making religious knowledge accessible,
                  comprehensive, and purposeful.
                </p>
                <ul>
                  <li>Qur'an recitation with Tajweed and Qira'at</li>
                  <li>Memorization (Hifz) of the Qur'an</li>
                  <li>
                    Core Islamic beliefs including Salah, Fasting, Zakat, and
                    Hajj
                  </li>
                  <li>Seerah of the Prophet Muhammad (peace be upon him)</li>
                  <li>Islamic jurisprudence and Tafsir: Bahar-e-Shariat</li>
                  <li>
                    Special curricula for women, children, and Urdu-speaking
                    learners
                  </li>
                </ul>
                <p>
                  All courses are supervised by qualified and sincere teachers
                  to ensure that knowledge goes beyond books and becomes part of
                  the heart and daily life.
                </p>
              </>
            )}
          </div>

          {/* Call to Action */}
          <div className="mb-4">
            {this.setState.siteLanguage === "ur" ? (
              <>
                <h4>دعوتِ عمل</h4>
                <p>
                  یہ وقت ہے کہ ہم دین کے طالبِ علم بنیں۔ دین سیکھنا، سکھانا اور پھیلانا صرف علماء کی ذمہ داری نہیں، بلکہ ہر باشعور مسلمان کا فریضہ ہے۔ "Learn Quran Easily" اس راہ میں آپ کا مخلص ساتھی ہے۔
                </p>
              </>
            ) : this.setState.siteLanguage === "ro" ? (
              <>
                <h4>Da’wat-e-Amal</h4>
                <p>
                  Ye Waqt Hai Ke Hum Deen Ke Taalib-e-Ilm Banein. Deen Seekhna, Sikhaana Aur Phailana Sirf Ulema Ki Zimmedari Nahin, Balki Har Ba Sha’oor Musalmaan Ka Fariza Hai. Learn Quran Easily” Is Raah Mein Aap Ka Mukhlish Saathi Hai.
                </p>
              </>
            ) : (
              <>
                <h4>Call to Action</h4>
                <p>
                  Now is the time for us to become students of Deen. Learning,
                  teaching, and spreading the message of Islam is not just the
                  duty of scholars—it is the responsibility of every conscious
                  Muslim. Learn Quran Easily is your dedicated companion on this
                  sacred journey.
                </p>
              </>
            )}
          </div>

          {/* Dua */}
          <div className="mb-4">
            {this.setState.siteLanguage === "ur" ? (
              <>
                <h4>اختتامی دعا</h4>
                <p>
                  اے اللہ! ہمیں علمِ دین سیکھنے کی توفیق عطا فرما۔
                  <br />
                  ہمیں قرآن و سنت سے جُڑنے، ان پر عمل کرنے، اور اپنی زندگیاں ان کے مطابق ڈھالنے کی ہمت عطا فرما۔
                  <br />
                  ہمیں اُن بندگانِ صالح کے نقشِ قدم پر چلنے والا بنا، جنہوں نے دین کی خدمت میں اپنی زندگیاں وقف کر دیں۔
                  <br />
                  اے رب العالمین! ہمیں علم و عمل اور اخلاص کی وہ دولت عطا فرما جو ہمیں دنیا و آخرت کی کامیابی سے ہمکنار کرے۔ آمین۔
                  </p>
              </>
            ) : this.setState.siteLanguage === "ro" ? (
              <>
                <h4>Ikhtitaami Dua</h4>
                <p>
                 Ae Allah! Humein Ilm-e-Deen Seekhne Ki Taufeeq Ata Farma.
                  <br />
                 Humein Qur’an O Sunnat Se Jurhne, In Par Amal Karne, Aur Apni Zindagiyon Ko In Ke Mutabiq Dhaalne Ki Himmat Ata Farma.
                  <br />
                 Humein Un Bandgaan-e-Saalih Ke Naqsh-e-Qadam Par Chalne Wala Bana, Jinhu Ne Deen Ki Khidmat Mein Apni Zindagiyan Waqf Kar Deen.
                  <br />
                  Ae Rabb-ul-Aalameen! Humein Ilm, O Amal Aur Ikhlaas Ki Who Daulat Ata Farma Jo Humein Duniya O Aakhirat Ki Kamiyabi Se Humkinar Kare. Aameen.
                </p>
              </>
            ) : (
              <>
                <h4>Concluding Prayer</h4>
                <p>
                  O Allah! Grant us the ability to seek and understand the
                  knowledge of Deen.
                  <br />
                  Help us connect with the Qur’an and Sunnah, act upon them, and
                  mold our lives according to their teachings.
                  <br />
                  Make us among the righteous servants who followed in the
                  footsteps of those who dedicated their lives to the service of
                  Islam.
                  <br />O Lord of the worlds! Bless us with the treasures of
                  knowledge, practice, and sincerity, and grant us success in
                  this world and the Hereafter. Ameen.
                </p>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
}
export default TeamOverview;
